import React from 'react'
import { useSelector } from 'react-redux'
import { Outlet } from 'react-router-dom'

import ConfirmationModal from '@/components/Modal/ConfirmationModal'
import FileHistoryModal from '@/components/Modal/FileHistoryModal'
import TimeoutPromptModal from '@/features/offers/components/Modal/OfferIdlePromptModal'
import { Box, Grid, GridItem } from '@chakra-ui/react'
import Breadcrumb from '../Breadcrumb'
import Header from '../Header'
import Sidebar from '../Sidebar'

//Redux

import { uiSelector } from '@/stores/ui/uiSlice'
import ModalRoot from './ModalRoot'

const MainLayout = ({ routes }) => {
  const { sidebarShow } = useSelector(uiSelector)

  return (
    <>
      <Grid
        templateAreas={`'sidebar header' 'sidebar main'`}
        gridTemplateRows={'90px auto'}
        templateColumns="auto 1fr"
        h="calc(100vh)"
      >
        <GridItem area="sidebar" as="aside" w="full" p={0}>
          <Sidebar show={sidebarShow} />
        </GridItem>
        <GridItem area="header" zIndex="200" position={'sticky'} top="0" alignSelf={'start'} w="100%">
          <Box bg="white">
            <Header />
            <Breadcrumb routes={routes} />
          </Box>
        </GridItem>

        <GridItem as="main" area="main" w="full" overflowY={'scroll'} overflowX={'hidden'}>
          <Box>
            <Outlet />
          </Box>
        </GridItem>
      </Grid>

      <ModalRoot />

      <FileHistoryModal />
      <ConfirmationModal />
      <TimeoutPromptModal />
    </>
  )
}

export default MainLayout
